module.exports = __webpack_public_path__ + "static/media/primary-residence.860e4276.svg";